import React from 'react';
import cn from 'classnames';
import styles from './TableHeadCell.module.scss';

const TableHeadCell = ({ children, className, ...props }) => {
  return (
    <th
      {...props}
      className={cn(styles.root, className)}
    >
      <div className={styles.headCellChildrenWrap}>{children}</div>
    </th>
  );
};

export default TableHeadCell;
